/* DN (Sentry DE-1VF, Vorbild US-1Y): jQuery-Ajax als Promise mit Fangnetz. Ein 422 von /cart/update.js
   ("Parameter updates ist ungueltig", ausgeloest durch leere Keys im color-array) lief vorher als
   unbehandelte Promise-Ablehnung durch. Der error-Callback im Aufruf bleibt, die Ablehnung wird hier zu null. */
window.dnAjaxSicher = window.dnAjaxSicher || function (dnOptionen) {
  return $.ajax(dnOptionen).catch(function () { return null; });
};
window.dnGetJsonSicher = window.dnGetJsonSicher || function (dnUrl, dnErfolg) {
  return $.getJSON(dnUrl, dnErfolg).catch(function () { return null; });
};
/* DN (Sentry US-1Y): jQuery-Ajax als Promise mit Fangnetz - ein 422 von /cart/update.js
   ("updates parameter is invalid") loeste vorher eine unbehandelte Promise-Ablehnung aus.
   Der error-Callback im Aufruf bleibt, die Ablehnung wird hier in null umgewandelt. */
window.dnAjaxSicher = window.dnAjaxSicher || function (dnOptionen) {
  return $.ajax(dnOptionen).catch(function () { return null; });
};
function formatExpandedItemsToJsonArray(items) {
  const jsonArray = items.map(item => ({
    id: `gid://shopify/ProductVariant/${item.id}`,
    quantity: 1,
    customKey: item.price,
    isOptional: item.optional
  }));
  return JSON.stringify(jsonArray);
}


function generateUID() {
    var firstPart = (Math.random() * 46656) | 0;
    var secondPart = (Math.random() * 46656) | 0;
    firstPart = ("000" + firstPart.toString(36)).slice(-3);
    secondPart = ("000" + secondPart.toString(36)).slice(-3);
    return firstPart + secondPart;
}

async function addRelated(variantIdArray, $that, optionalIndex) {
    let optionalIndexInt = optionalIndex.map(function(str) { return parseInt(str) });
    let set_id = generateUID();

    let reduced_obj = variantIdArray.reduce(function(obj, b) {
        obj[b] = ++obj[b] || 1;
        return obj;
    }, {});

    let indexedObj = {};

    for (let i = 0; i < variantIdArray.length; i++) {
        indexedObj[i] = variantIdArray[i];
    }

    var product_data = [];
 
    let child_variant_ids = "";
    let free_variant_ids = "";
  
    Object.keys(reduced_obj).forEach((key, index) => {
        if (index != 0) {
            if (!child_variant_ids.includes(key)) {
                child_variant_ids += key + ":" + reduced_obj[key];
                child_variant_ids += '__';
            }
        }
    });
    

     let expandedItems =   [];
     
    $('.subscription_widget_04 .color-selection__grid-item:not(.disabled-color) color-switcher.color-selection__image.coladded').each(function(index) {
        const priceVar = parseInt($(this).attr('data-original-price'), 10) / 100;
        const variantId = parseInt($(this).attr('variant-id'), 10);
        let isOptional = false;
        if ($(this).hasClass('optional-switcher')) {
            isOptional = true;
        }

        expandedItems.push({ id: variantId, price: priceVar, optional: isOptional });
        
        if (free_variant_ids === "") {
            free_variant_ids = `${variantId}`;
        } else {
            free_variant_ids += `,${variantId}`;
        }
    });


    $('.template_suffix_press-ons-valentines-v2 .color-selection__grid-item:not(.disabled-color) color-switcher.color-selection__image.coladded').each(function(index) {
        const priceVar = parseInt($(this).attr('data-original-price'), 10) / 100;
        const variantId = parseInt($(this).attr('variant-id'), 10);
        let isOptional = false;
        if ($(this).hasClass('optional-switcher')) {
            isOptional = true;
        }

        expandedItems.push({ id: variantId, price: priceVar, optional: isOptional });
        
        if (free_variant_ids === "") {
            free_variant_ids = `${variantId}`;
        } else {
            free_variant_ids += `,${variantId}`;
        }
    });

    $('.template_suffix_press-ons-valentines-listicle .color-selection__grid-item:not(.disabled-color) color-switcher.color-selection__image.coladded').each(function(index) {
        const priceVar = parseInt($(this).attr('data-original-price'), 10) / 100;
        const variantId = parseInt($(this).attr('variant-id'), 10);
        let isOptional = false;
        if ($(this).hasClass('optional-switcher')) {
            isOptional = true;
        }

        expandedItems.push({ id: variantId, price: priceVar, optional: isOptional });
        
        if (free_variant_ids === "") {
            free_variant_ids = `${variantId}`;
        } else {
            free_variant_ids += `,${variantId}`;
        }
    });

    const expandJSON = formatExpandedItemsToJsonArray(expandedItems);
    console.log(expandJSON);

    

    $('.free_in_set_item.coladded:not(.notAdded)').each(function() {
      if ($(this).is(':visible')) {
        child_variant_ids += parseInt($(this).attr('data-variant')) + ":" + 1;
        child_variant_ids += '__';
      }
    });

  $('.free_product_hidden').each(function() {
    const sellingPlanId = $('.subscription_widget_04 input[name="subscription_widget_02"]:checked').val();
    if (sellingPlanId && sellingPlanId != 'one_time') {
        child_variant_ids += parseInt($(this).val()) + ":" + 1;
        child_variant_ids += '__';
    } else if ($(this).attr("data-main").includes("starter-set-soft-gel-press-ons") && $(this).attr('data-title') == "Beauty Bag") {
        child_variant_ids += parseInt($(this).val()) + ":" + 1;
        child_variant_ids += '__';
    }
  });

    
    for (let key in indexedObj) {
        if (indexedObj.hasOwnProperty(key)) {
            if (key == 0) {
                let props = {};
                props['_starter-set-parent'] = true;
                props['_bundle-parent'] = true;
              if(window.atcPriceCompare != undefined) props['_compareOriginalPrice'] = window.atcPriceCompare;
              if(window.atcPrice != undefined) props['_starter-price'] = window.atcPrice;
                props['_set'] = set_id;
                props['_variants_set'] = child_variant_ids;
                props['_childItemsJson'] = expandJSON;
                props['_free_variants'] = free_variant_ids;
                let prod = { quantity: 1, id: parseInt(indexedObj[key]), properties: props };
                product_data.push(prod);
            }
        }
    }


    if ($('.subscription_widget_04 input[name="subscription_widget_02"]:checked') && $('.subscription_widget_04 input[name="subscription_widget_02"]:checked').length > 0) {
        const sellingPlanId = $('.subscription_widget_04 input[name="subscription_widget_02"]:checked').val();
        if (sellingPlanId && sellingPlanId != 'one_time') {
            product_data.length = 0;
            const sellingPlanName = $('.subscription_widget_04 input[name="subscription_widget_02"]:checked').attr('data-plan-name');
            const variantTitle = $('.subscription_widget_04 input[name="subscription_widget_02"]:checked').attr('data-variant-title').replace(/ /g, "-");
            const parentProductId = parseInt($('.shopify-product-form input[name="product-id"]').val())
            $('.subscription_widget_04 .color-selection__grid-item:not(.disabled-color) color-switcher.color-selection__image.coladded:not(.free_gift)').each(function(index) {
                let required_prod = { quantity: 1, id: parseInt($(this).attr('variant-id')) };
                let percentOff = parseFloat($('#pick-color-id').attr('data-optional-off')) || 0;
                    required_prod["properties"] = {
                        '_set_id': set_id,
                        '_product_id': parentProductId+"_"+variantTitle,
                        'Subscription Discount': percentOff + "%"
                    };
                if ($(this).attr('data-selling-1-plan-name') && $(this).attr('data-selling-1-plan-id') && sellingPlanName == $(this).attr('data-selling-1-plan-name')) {
                    required_prod["selling_plan"] = $(this).attr('data-selling-1-plan-id');
                } else if ($(this).attr('data-selling-2-plan-name') && $(this).attr('data-selling-2-plan-id') && sellingPlanName == $(this).attr('data-selling-2-plan-name')) {
                    required_prod["selling_plan"] = $(this).attr('data-selling-2-plan-id');
                } else if ($(this).attr('data-selling-3-plan-name') && $(this).attr('data-selling-3-plan-id') && sellingPlanName == $(this).attr('data-selling-3-plan-name')) {
                    required_prod["selling_plan"] = $(this).attr('data-selling-3-plan-id');
                } else if ($(this).attr('data-selling-4-plan-name') && $(this).attr('data-selling-4-plan-id') && sellingPlanName == $(this).attr('data-selling-4-plan-name')) {
                    required_prod["selling_plan"] = $(this).attr('data-selling-4-plan-id');
                } else if ($(this).attr('data-selling-5-plan-name') && $(this).attr('data-selling-5-plan-id') && sellingPlanName == $(this).attr('data-selling-5-plan-name')) {
                    required_prod["selling_plan"] = $(this).attr('data-selling-5-plan-id');
                } else if ($(this).attr('data-selling-6-plan-name') && $(this).attr('data-selling-6-plan-id') && sellingPlanName == $(this).attr('data-selling-6-plan-name')) {
                    required_prod["selling_plan"] = $(this).attr('data-selling-6-plan-id');
                } else if ($(this).attr('data-selling-7-plan-name') && $(this).attr('data-selling-7-plan-id') && sellingPlanName == $(this).attr('data-selling-7-plan-name')) {
                    required_prod["selling_plan"] = $(this).attr('data-selling-7-plan-id');
                } else {
                    required_prod["selling_plan"] = sellingPlanId;
                }
                
                product_data.push(required_prod);
            });

            $('.template_suffix_press-ons-valentines-v2 .color-selection__grid-item:not(.disabled-color) color-switcher.color-selection__image.coladded:not(.free_gift)').each(function(index) {
                let required_prod = { quantity: 1, id: parseInt($(this).attr('variant-id')) };
                let percentOff = parseFloat($('#pick-color-id').attr('data-optional-off')) || 0;
                    required_prod["properties"] = {
                        '_set_id': set_id,
                        '_product_id': parentProductId+"_"+variantTitle,
                        'Subscription Discount': percentOff + "%"
                    };
                    required_prod["selling_plan"] = sellingPlanId;
                
                product_data.push(required_prod);
            });

            $('.template_suffix_press-ons-valentines-listicle .color-selection__grid-item:not(.disabled-color) color-switcher.color-selection__image.coladded:not(.free_gift)').each(function(index) {
                let required_prod = { quantity: 1, id: parseInt($(this).attr('variant-id')) };
                let percentOff = parseFloat($('#pick-color-id').attr('data-optional-off')) || 0;
                    required_prod["properties"] = {
                        '_set_id': set_id,
                        '_product_id': parentProductId+"_"+variantTitle,
                        'Subscription Discount': percentOff + "%"
                    };
                    required_prod["selling_plan"] = sellingPlanId;
                
                product_data.push(required_prod);
            });
        }
    }



    $('.free_in_set_item.coladded:not(.notAdded)').each(function() {
      if ($(this).is(':visible')) {
        let upsell_prod_opt = { quantity: 1, id: parseInt($(this).attr('data-variant')) };
        upsell_prod_opt["properties"] = {
            '_bundled-product': true,
            '_bundled-free': true,
            '_discountAmount': parseFloat($(this).attr('data-discount')),
            '_set_id': set_id
        };
        product_data.push(upsell_prod_opt);
      }
    });

    if ($('.subscription_widget_04 input[name="subscription_widget_02"]:checked') && $('.subscription_widget_04 input[name="subscription_widget_02"]:checked').length > 0) {
        const sellingPlanId = $('.subscription_widget_04 input[name="subscription_widget_02"]:checked').val();
        if (sellingPlanId && sellingPlanId != 'one_time') {
            const sellingPlanName = $('.subscription_widget_04 input[name="subscription_widget_02"]:checked').attr('data-plan-name');
            const variantTitle = $('.subscription_widget_04 input[name="subscription_widget_02"]:checked').attr('data-variant-title').replace(/ /g, "-");
            const parentProductId = parseInt($('.shopify-product-form input[name="product-id"]').val())
            $('.subscription_widget_04 .color-selection__grid-item:not(.disabled-color) color-switcher.color-selection__image.coladded.free_gift').each(function(index) {
                let required_prod = { quantity: 1, id: parseInt($(this).attr('variant-id')) };
                    required_prod["properties"] = {
                        '_product_id': parentProductId+"_"+variantTitle,
                        '_bundled-product': true,
                        '_bundled-free': true,
                        '_discountAmount': parseFloat($(this).attr('data-original-price')),
                        'Valentines Offer': "-" + window.globalMoneyFm($(this).attr('data-original-price')),
                        '_set_id': set_id
                    };
                product_data.push(required_prod);
            });

            $('.template_suffix_press-ons-valentines-v2 .color-selection__grid-item:not(.disabled-color) color-switcher.color-selection__image.coladded.free_gift').each(function(index) {
                let required_prod = { quantity: 1, id: parseInt($(this).attr('variant-id')) };
                    required_prod["properties"] = {
                        '_product_id': parentProductId+"_"+variantTitle,
                        '_bundled-product': true,
                        '_bundled-free': true,
                        '_discountAmount': parseFloat($(this).attr('data-original-price')),
                        'Valentines Offer': "-" + window.globalMoneyFm($(this).attr('data-original-price')),
                        '_set_id': set_id
                    };
                product_data.push(required_prod);
            });

            $('.template_suffix_press-ons-valentines-listicle .color-selection__grid-item:not(.disabled-color) color-switcher.color-selection__image.coladded.free_gift').each(function(index) {
                let required_prod = { quantity: 1, id: parseInt($(this).attr('variant-id')) };
                    required_prod["properties"] = {
                        '_product_id': parentProductId+"_"+variantTitle,
                        '_bundled-product': true,
                        '_bundled-free': true,
                        '_discountAmount': parseFloat($(this).attr('data-original-price')),
                        'Valentines Offer': "-" + window.globalMoneyFm($(this).attr('data-original-price')),
                        '_set_id': set_id
                    };
                product_data.push(required_prod);
            });
        }
    }

    $('.free_product_hidden').each(function() {
        const sellingPlanId = $('.subscription_widget_04 input[name="subscription_widget_02"]:checked').val();
        if (sellingPlanId && sellingPlanId != 'one_time') {
            let upsell_prod_opt = { quantity: 1, id: parseInt($(this).val()) };
            upsell_prod_opt["properties"] = {
                '_bundled-product': true,
                '_bundled-free': true,
                '_discountAmount': parseFloat($(this).attr('data-discount')),
                'WELCOME GIFT': "-" + window.globalMoneyFm($(this).attr('data-discount')),
                '_set_id': set_id
            };
            product_data.push(upsell_prod_opt);
        } else if (sellingPlanId && $(this).attr("data-main").includes("starter-set-soft-gel-press-ons") && $(this).attr('data-title') == "Beauty Bag") {
            let upsell_prod_opt = { quantity: 1, id: parseInt($(this).val()) };
            upsell_prod_opt["properties"] = {
                '_bundled-product': true,
                '_bundled-free': true,
                '_discountAmount': parseFloat($(this).attr('data-discount')),
                'WELCOME GIFT': "-" + window.globalMoneyFm($(this).attr('data-discount')),
                '_set_id': set_id
            };
            product_data.push(upsell_prod_opt);
        }
    });



    console.log(product_data);

    async function addItemsToCartAndProceed() {
        try {
            const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
                body: JSON.stringify({ items: product_data }),
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'xmlhttprequest'
                },
                method: 'POST'
            });

            const responseJson = await response.json();

            if (!response.ok) {
                throw new Error(responseJson["description"] || "Error adding items to cart");
            }

            if (sessionStorage.getItem("utm_ablyft")) {
                const utm_ablyft = JSON.parse(sessionStorage.getItem("utm_ablyft"));
                  const cartAttributes = {
                        ablyft_source: 'ab_test',
                        ablyft_experiment_id: utm_ablyft.experiment_id,
                        ablyft_variation_id: utm_ablyft.variation_id,
                        ablyft_campaign: utm_ablyft.product_handle
                    };

                const attrResponse = await fetch(`${window.themeVariables.routes.cartUpdateUrl}.js`, {
                    body: JSON.stringify({
                        attributes: cartAttributes
                    }),
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'xmlhttprequest'
                    },
                    method: 'POST'
                });

                const attrResponseJson = await attrResponse.json();

                if (!attrResponse.ok) {
                    throw attrResponseJson;
                }
            }

            
            $('.loader-button__text').show();
            $('.loader-button__loader').hide();

            if(!window.upsellPopupActive){
                $('.loader-button__text').show();
                $('.loader-button__loader').hide();
                $('#AddToCartSub').find('.loader-button__text').show();
                $('#AddToCartSub').find('.loader-button__loader').hide();
                // sessionStorage.setItem('wentToCheckout', '1');
                window.location.href = '/checkout';
            } else {
                $('#AddToCartSub').find('.loader-button__text').show();
                $('#AddToCartSub').find('.loader-button__loader').hide();
                fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
                    const cartContent = await response2.json();
                    window.upsellPopupFunc(cartContent, $that);
                });
            }

            
            // if ($('body').hasClass('direct_checkout_pd')) {
            //     window.location.href = '/checkout';
            // } else {
            //     setTimeout(function() {
            //         $('#MainPaymentContainer').removeAttr('disabled').removeClass('disabled');
            //     }, 200);

            //     fetch('/?section_id=mini-cart').then(res => res.text()).then(data => {
            //         const html = document.createElement("div");
            //         html.innerHTML = data;
            //         const newbox = html.querySelector("#mini-cart").innerHTML;
            //         document.querySelector('#mini-cart').innerHTML = newbox;
            //     })

            //     fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
            //         const cartContent = await response2.json();

            //         if(!window.upsellPopupActive){
                        
            //             document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
            //                 bubbles: true,
            //                 detail: {
            //                     cart: cartContent
            //                 }
            //             }));

            //             document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            //                 bubbles: true,
            //                 detail: {
            //                     cart: cartContent,
            //                     openMiniCart: window.themeVariables.settings.cartType === "drawer" && $that.closest(".drawer") === null
            //                 }
            //             }));
            //         } else {
            //             window.upsellPopupFunc(cartContent, $that);
            //         }

            //     });
            //   const cartUpdateEvent = new Event('cartUpdate');
            //   window.dispatchEvent(cartUpdateEvent);
              
            //     $('.loader-button__text').show();
            //     $('.loader-button__loader').hide();
            // }

            $that.dispatchEvent(new CustomEvent("cart-notification:show", {
                bubbles: true,
                cancelable: true,
                detail: {
                    status: "success",
                    error: ""
                }
            }));
        } catch (error) {
            $that.dispatchEvent(new CustomEvent("cart-notification:show", {
                bubbles: true,
                cancelable: true,
                detail: {
                    status: "error",
                    error: error.message
                }
            }));
        }
    }

    // Call the function to add items to the cart and proceed
    addItemsToCartAndProceed();
}

$(document).ready(function() {
  
$('body').on('click', '.inventory-product', async function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).find('.loader-button__text').hide();
    $(this).find('.loader-button__loader').show();
    $('#AddToCartSub').find('.loader-button__text').hide();
    $('#AddToCartSub').find('.loader-button__loader').show();

    $('#MainPaymentContainer').attr('disabled', 'disabled').addClass('disabled');

    const $that = this;

    if ($(this).hasClass('updateProduct')) {
        const pre_set_id = $(this).attr('set-id'); // Get the pre_set_id
        let keysToRemove = []; // Array to store keys of items to be removed

        // Get the cart data
        await window.dnGetJsonSicher(`${window.themeVariables.routes.cartUrl}.js`, function (cart) {
            const items = cart.items;

            // Iterate through each cart item
            items.forEach((item) => {
                // Check for the _set_id or _set property
                if ((item.properties && item.properties._set_id === pre_set_id) ||
                    (item.properties && item.properties._set === pre_set_id)) {
                    keysToRemove.push(item.key); // Store the item's key
                }
            });
        });

        // If we have keys to remove, make a single API call to remove them
        if (keysToRemove.length > 0) {
            const updates = {}; // Object to hold update data for cart API
            keysToRemove.forEach((key) => {
                updates[key] = 0; // Setting quantity to 0 removes the item
            });

            await window.dnAjaxSicher({
                url: `${window.themeVariables.routes.cartUpdateUrl}.js`,
                method: 'POST',
                dataType: 'json',
                data: { updates: updates },
                success: function (data) {
                console.log(data);
                },
                error: function (error) {
                    console.error('Error removing items from cart:', error);
                }
            });
        }
    } else if ($(this).hasClass('updateSingleProducts')) {
  
        const pre_set_id = $(this).attr('color-array');
        let keysToRemove = (pre_set_id?.split(',') || []).map((dnKey) => dnKey.trim()).filter(Boolean); /* DN: leere Keys ergeben ein 422 */
      
        $(this).attr('color-array', '');
        $(this).removeClass('updateSingleProducts')

        // If we have keys to remove, make a single API call to remove them
        if (keysToRemove.length > 0) {
            const updates = {}; // Object to hold update data for cart API
            keysToRemove.forEach((key) => {
                updates[key] = 0; // Setting quantity to 0 removes the item
            });

            await window.dnAjaxSicher({
                url: `${window.themeVariables.routes.cartUpdateUrl}.js`,
                method: 'POST',
                dataType: 'json',
                data: { updates: updates },
                success: function (data) {
                console.log(data);
                },
                error: function (error) {
                    console.error('Error removing items from cart:', error);
                }
            });
        }
    }

    if ($('input[name="subscription_widget_02"]:checked').val() == "one_time") {
        window.dispatchEvent(new CustomEvent('atc_otp'))
    } else {
        window.dispatchEvent(new CustomEvent('atc_subscription'));
    }

    // Collect other items
    let items = [];
    let itemsOptionalIndex = [];

    items.push(parseInt($('.product-form__buy-buttons input[name="id"]').val()));

    $('.subscription_widget_04 .color-selection__grid-item:not(.disabled-color) color-switcher.color-selection__image.optional-switcher.coladded').each(function(index) {
        items.push(parseInt($(this).attr('variant-id')));
        itemsOptionalIndex.push(items.length - 1);
    });

    $('.template_suffix_press-ons-valentines-v2 .color-selection__grid-item:not(.disabled-color) color-switcher.color-selection__image.optional-switcher.coladded').each(function(index) {
        items.push(parseInt($(this).attr('variant-id')));
        itemsOptionalIndex.push(items.length - 1);
    });

    $('.template_suffix_press-ons-valentines-listicle .color-selection__grid-item:not(.disabled-color) color-switcher.color-selection__image.optional-switcher.coladded').each(function(index) {
        items.push(parseInt($(this).attr('variant-id')));
        itemsOptionalIndex.push(items.length - 1);
    });

  addRelated(items, $that, itemsOptionalIndex);
  
  console.log(items);
  
});
  
});